// /src/pages/LeadClientePage.jsx
// VERSÃO 2.0 SUPREMA - ELITE CLIENT DIRECTORY & 7 ESTAÇÕES SYNC

import React, { useState, useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';
import { LeadExecutionEngine } from '../api/LeadExecutionEngine';
import { FiAward, FiStar, FiMail, FiPhoneCall, FiShield, FiActivity, FiUser, FiChevronRight } from 'react-icons/fi';

export default function LeadClientePage() {
    const [clientes, setClientes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        LeadExecutionEngine.listarPorStatus('CLIENTE')
            .then(setClientes)
            .finally(() => setLoading(false));
    }, []);

    return (
        <MainLayout>
            <div className="w-full min-h-screen transition-all duration-500 pb-40" 
                 style={{ backgroundColor: 'var(--bg-main)' }}>
                
                <div className="max-w-[1600px] mx-auto p-8 md:p-16 space-y-16">
                    
                    {/* 🛰️ HEADER MONUMENTAL (HUD DE CONVERSÃO) */}
                    <header className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-10 border-b pb-16 relative overflow-hidden"
                            style={{ borderColor: 'var(--border-color)' }}>
                        
                        <div className="flex items-center gap-10 relative z-10">
                            <div className="w-24 h-24 rounded-[2.5rem] border shadow-2xl flex items-center justify-center transition-all hover:scale-110"
                                 style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-color)', color: 'var(--accent-color)' }}>
                                <FiAward size={48} className="animate-pulse" />
                            </div>
                            <div>
                                <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-auto leading-none mb-4">
                                    Clientes <span className="text-accent">Elite</span>
                                </h1>
                                <div className="flex items-center gap-6">
                                    <div className="px-5 py-2 rounded-2xl border border-auto bg-card-auto shadow-sm flex items-center gap-3">
                                        <div className="w-2 h-2 rounded-full bg-green-500 animate-ping" />
                                        <span className="text-[10px] font-black uppercase tracking-[0.4em] text-auto opacity-60">
                                            Contratos Efetivados
                                        </span>
                                    </div>
                                    <span className="text-[10px] font-black uppercase tracking-widest text-accent">Protocolo de Sucesso MOS</span>
                                </div>
                            </div>
                        </div>

                        {/* COUNTER TÁTICO */}
                        <div className="px-12 py-6 bg-card-auto border border-auto rounded-[2.5rem] shadow-2xl backdrop-blur-xl group hover:border-accent/30 transition-all">
                            <span className="block text-[9px] font-black uppercase text-auto opacity-30 tracking-[0.3em] mb-2 text-right">Volume Convertido</span>
                            <div className="flex items-center gap-4">
                                <FiActivity className="text-accent opacity-20" size={20} />
                                <span className="text-5xl font-black text-accent font-mono tracking-tighter">
                                    {clientes.length.toString().padStart(3, '0')}
                                </span>
                            </div>
                        </div>
                    </header>

                    {/* 🚀 GRADE DE CLIENTES (GRID DE ALTA DENSIDADE) */}
                    {loading ? (
                        <div className="py-40 text-center flex flex-col items-center justify-center">
                            <FiActivity className="animate-spin text-accent mb-6" size={50} />
                            <p className="text-[11px] font-black uppercase tracking-[0.6em] text-auto opacity-30">Escaneando Base de Dados...</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
                            {clientes.map(cliente => (
                                <div key={cliente._id} 
                                     className="group relative p-10 rounded-[3rem] border shadow-2xl transition-all duration-700 hover:-translate-y-2 hover:border-accent/40"
                                     style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-color)' }}>
                                    
                                    <FiStar className="absolute top-10 right-10 text-accent opacity-5 group-hover:opacity-100 group-hover:scale-125 transition-all duration-700" size={24} />
                                    
                                    {/* AVATAR TÁTICO (INICIAL) */}
                                    <div className="w-20 h-20 rounded-[2rem] border flex items-center justify-center text-accent font-black text-3xl mb-10 shadow-inner group-hover:rotate-6 transition-transform"
                                         style={{ backgroundColor: 'var(--bg-main)', borderColor: 'var(--border-color)' }}>
                                        {cliente.name[0]}
                                    </div>
                                    
                                    <div className="space-y-2 mb-10">
                                        <h3 className="font-black text-auto uppercase text-xl tracking-tighter group-hover:text-accent transition-colors duration-500">
                                            {cliente.name}
                                        </h3>
                                        <div className="flex items-center gap-2 px-3 py-1 rounded-lg bg-accent/5 border border-accent/10 w-fit">
                                            <FiShield size={10} className="text-accent" />
                                            <span className="text-[8px] font-black uppercase text-accent tracking-widest">Ativo Premium</span>
                                        </div>
                                    </div>
                                    
                                    {/* INFO DE CONTATO CÉLULA */}
                                    <div className="space-y-5 mb-12 border-t border-auto pt-8">
                                        <div className="flex items-center gap-4 text-auto group/info">
                                            <div className="w-8 h-8 rounded-lg border border-auto flex items-center justify-center opacity-30 group-hover/info:opacity-100 group-hover/info:border-accent transition-all">
                                                <FiMail size={12} className="group-hover/info:text-accent" />
                                            </div>
                                            <span className="text-[10px] font-bold uppercase tracking-widest opacity-40 group-hover/info:opacity-100 truncate">
                                                {cliente.email}
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-4 text-auto group/info">
                                            <div className="w-8 h-8 rounded-lg border border-auto flex items-center justify-center opacity-30 group-hover/info:opacity-100 group-hover/info:border-accent transition-all">
                                                <FiPhoneCall size={12} className="group-hover/info:text-accent" />
                                            </div>
                                            <span className="text-[10px] font-bold uppercase tracking-widest opacity-40 group-hover/info:opacity-100">
                                                {cliente.phone}
                                            </span>
                                        </div>
                                    </div>

                                    {/* BOTÃO DE COMANDO */}
                                    <button className="w-full py-5 rounded-2xl font-black uppercase text-[10px] tracking-[0.4em] transition-all flex items-center justify-center gap-3 border border-auto hover:scale-[1.02] active:scale-95"
                                            style={{ backgroundColor: 'var(--bg-main)', color: 'var(--text-primary)' }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'var(--accent-color)';
                                                e.currentTarget.style.color = '#000';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'var(--bg-main)';
                                                e.currentTarget.style.color = 'var(--text-primary)';
                                            }}>
                                        Dossiê Completo <FiChevronRight />
                                    </button>

                                    {/* Linha Decorativa Inferior */}
                                    <div className="absolute bottom-0 left-10 right-10 h-1 bg-accent scale-x-0 group-hover:scale-x-100 transition-transform duration-700 rounded-t-full shadow-[0_0_15px_var(--accent-color)]" />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </MainLayout>
    );
}